const doc = [({"installment":"Pagamento a rate", "limited_subscription":"Abbonamento limitato", "one_time":"Una volta", "subscription":"Abbonamento"})];
module.exports = doc.length <= 1 ? doc[0] : doc;